function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8 0C3.58214 0 0 3.58214 0 8C0 12.4179 3.58214 16 8 16C12.4179 16 16 12.4179 16 8C16 3.58214 12.4179 0 8 0ZM8 14.6429C4.33214 14.6429 1.35714 11.6679 1.35714 8C1.35714 4.33214 4.33214 1.35714 8 1.35714C11.6679 1.35714 14.6429 4.33214 14.6429 8C14.6429 11.6679 11.6679 14.6429 8 14.6429Z",
  fill: "#FFA900"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.1195 10.2608L8.57311 8.4197V4.00004C8.57311 3.92146 8.50882 3.85718 8.43025 3.85718H7.57132C7.49275 3.85718 7.42847 3.92146 7.42847 4.00004V8.91791C7.42847 8.96434 7.4499 9.0072 7.48739 9.03398L10.441 11.1876C10.5052 11.234 10.5945 11.2197 10.641 11.1572L11.1517 10.4608C11.1981 10.3947 11.1838 10.3054 11.1195 10.2608Z",
  fill: "#FFA900"
});

const SvgLoadingIcon = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLoadingIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/loading-icon.6afc570f.svg";
export { ForwardRef as ReactComponent };